import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0F0F13] text-white/60">
                <div className="font-display uppercase tracking-widest text-sm">Checking session…</div>
            </div>
        );
    }
    if (!user || user.role !== "admin") {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
}
